import { render, staticRenderFns } from "./OrdercaigougoodsDetails.vue?vue&type=template&id=25e6f0dd&scoped=true"
import script from "./OrdercaigougoodsDetails.vue?vue&type=script&lang=js"
export * from "./OrdercaigougoodsDetails.vue?vue&type=script&lang=js"
import style0 from "./OrdercaigougoodsDetails.vue?vue&type=style&index=0&id=25e6f0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e6f0dd",
  null
  
)

export default component.exports